import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';

export type MapProductPolicy = {
  map_product_policy_id?: number;
  product_policy_id?: number;
  policy_status?: string;
  is_enable?: string;
  product_id?: number;
  created_at?: number;
};

const $http = new APIManager();

const Api = {
  getMapProductPolicies: (params?: { [key: string]: string | number }) =>
    $http.get(APIConstant.GETS_MAP_PRODUCT_POLICY, params),
  createMapProductPolicy: (params?: { [key: string]: string | number }) =>
    $http.post(APIConstant.CREATE_MAP_PRODUCT_POLICY, params),

  /**
   * [PUT] ProductPolicy
   * --
   */
  updateBulkProductPolicy: async (body: MapProductPolicy[]) => {
    try {
      const res = await $http.bulk(
        APIConstant.BULK_UPDATE_MAP_PRODUCT_POLICY,
        body,
        'PUT'
      );

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
